import type { CalendarContextStore } from '@/components/calendar/context';
import { createContext } from 'react';

const CalendarContext = createContext<CalendarContextStore | null>(null);

CalendarContext.displayName = 'CalendarContext';

export default CalendarContext;
